import {useMemo} from "react";

import {useTranslation} from "react-i18next";

export const useReportOptions = () => {
  const {t} = useTranslation();

  const SIMULATIONS_REPORT_OPTIONS = useMemo(
    () => [
      {id: 0, name: t("report_options.dialog")},
      {id: 1, name: t("report_options.avatar")},
      {id: 2, name: t("report_options.voice")},
      {id: 3, name: t("report_options.sound")},
      {id: 4, name: t("report_options.other")},
    ],
    [t],
  );

  const USER_REPORT_OPTIONS = useMemo(
    () => [
      {id: 0, name: t("report_options.country")},
      {id: 1, name: t("report_options.region")},
    ],
    [t],
  );

  return {
    SIMULATIONS_REPORT_OPTIONS,
    USER_REPORT_OPTIONS,
  };
};
